import {SxProps} from '@mui/material';

export const STYLES = {
  label: {
    height: '19px',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#263238',
    opacity: 0.8,
  },
  field: {
    position: 'relative',
    backgroundColor: '#FFFFFF',

    '& .MuiInputBase-input': {
      padding: '10px 20px',
      height: '44px',
      boxSizing: 'border-box',
    },

    '& fieldset': {
      border: '1px solid #7D8488',
      borderRadius: '6px',
    },
  },
} as const satisfies SxProps;
